// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-coin-content {
  align-items: center;
  background-color: rgba( 166, 166, 166 ,  1 );
  background-color: rgba( var(--palette-neutral-30,166, 166, 166) ,  1 );
  border-radius: 50%;
  color: white;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
  user-select: none;
}
@media (forced-colors: active) {
  .bolt-coin-content {
    background-color: WindowText;
  }
}
.bolt-coin-content.using-image {
  object-fit: cover;
  background-color: transparent;
}
.bolt-coin-content.pending-load-image {
  visibility: hidden;
}
.bolt-coin-content.size16 {
  font-size: 0.6875rem;
  width: 1rem;
  height: 1rem;
}
.bolt-coin-content.size20 {
  font-size: 0.6875rem;
  width: 1.25rem;
  height: 1.25rem;
}
.bolt-coin-content.size24 {
  font-size: 0.6875rem;
  width: 1.5rem;
  height: 1.5rem;
}
.bolt-coin-content.size32 {
  font-size: 0.875rem;
  width: 2rem;
  height: 2rem;
}
.bolt-coin-content.size40 {
  font-size: 0.875rem;
  width: 2.5rem;
  height: 2.5rem;
}
.bolt-coin-content.size72 {
  font-size: 1.75rem;
  width: 4.5rem;
  height: 4.5rem;
}

/*# sourceMappingURL=Coin.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Coin/Coin.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Coin/Coin.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AACA;EACI,mBAAA;EACA,4CCiES;EDhET,sEAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EEAF,iBAAiB;ACqCf;ADnCJ;EACE;IACE,4BAA4B;EAC9B;AFCE;AECJ;EFCQ,iBAAA;EECN,6BAA6B;AFE3B;AEAJ;EACE,kBAAkB;AFKhB;AEHJ;EFKQ,oBAAA;EACA,WAAA;EEHN,YAAY;AFMV;AEJJ;EFMQ,oBAAA;EACA,cAAA;EEJN,eAAe;AFMb;AEJJ;EFMQ,oBAAA;EACA,aAAA;EEJN,cAAc;AFMZ;AEJJ;EFMQ,mBAAA;EACA,WAAA;EEJN,YAAY;AFMV;AEJJ;EFMQ,mBAAA;EACA,aAAA;EEJN,cAAc;AFMZ;AEJJ;EFMQ,kBAAA;EACA,aAAA;EEJN,cAAc;AAChB;;AAEA,mCAAmC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
